import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-white px-5 py-14 md:py-20" data-id="element-92" data-mp="26k9xmja7pdch">
      <div className="mx-auto max-w-5xl" data-id="element-93" data-mp="22lkd86qravjc">
        <SectionHeading title="What Changes When You Have a Structured Assessment Pathway?" data-id="element-94" data-mp="22iodccvclws9" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-95" data-mp="2za8o8j421ij9">
          <div className="rounded-3xl border-2 border-alert/20 bg-alert-light p-5 md:p-7" data-id="element-96" data-mp="2ud03qbvfp2eu">
            <div className="flex items-center gap-3" data-id="element-97" data-mp="2q9ak80tm9b0o">
              <span className="rounded-full bg-alert px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-98" data-mp="2qc6k3up0y9rr">
                Before
              </span>
              <h3 className="text-base font-extrabold leading-tight text-navy md:text-lg" data-id="element-99" data-mp="1ewrl6ld997u0">Without a structured workflow</h3>
            </div>
            <ul className="mt-5 space-y-3" data-id="element-100" data-mp="175cly1x0ubij">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-white px-4 py-3" data-id="element-101" data-mp="173jc6dr43b6b">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/10" data-id="element-102" data-mp="1c232eqcqn94h">
                    <XIcon className="h-4 w-4 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="133isoep5o9se" />
                  </span>
                  <span className="text-[15px] font-medium leading-snug text-navy/80" data-id="element-104" data-mp="oemncpehhavh">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/30 bg-[#EAF7EF] p-5 md:p-7" data-id="element-105" data-mp="fe6lfkde2bsq">
            <div className="flex items-center gap-3" data-id="element-106" data-mp="fcdbnw7hbbgi">
              <span className="rounded-full bg-cta px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-107" data-mp="jgl2byxhz1hd">
                After
              </span>
              <h3 className="text-base font-extrabold leading-tight text-navy md:text-lg" data-id="element-108" data-mp="aetwmu2yiuni">With the Post-Op Pathway™</h3>
            </div>
            <ul className="mt-5 space-y-3" data-id="element-109" data-mp="2c52h5o325r1k">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-white px-4 py-3" data-id="element-110" data-mp="27chq2ubjds1q">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-111" data-mp="23d0le33xoyxm">
                    <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-112" data-mp="1ye5usezq662y" />
                  </span>
                  <span className="text-[15px] font-semibold leading-snug text-navy" data-id="element-113" data-mp="2v10yrayi06uc">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] font-semibold leading-relaxed text-navy" data-id="element-114" data-mp="2m0vqkylhd4f4">
          Your clinical judgment remains essential.{' '}
          <span className="text-teal" data-id="element-115" data-mp="1anjvpd7p7w53">Your documentation workflow becomes more organized.</span>
        </p>

        <SectionCTA label="Make the Switch Now" data-id="element-116" data-mp="15n5lboimka3w" />
      </div>
    </section>;
}